import { z } from 'zod';

export const StockItemSchema = z.object({
    product_variation_id: z.string({ message: 'Product is required' }),
    quantity: z.coerce
        .number({
            message: 'Not to be empty!',
        })
        .min(1, 'Minimum qty 1'),
    purchase_price: z.coerce
        .number()
        .min(0.1, 'Purchase price must be greater than 0'),
    wholesale_price: z.coerce
        .number()
        .min(0.1, 'Wholesale price must be greater than 0'),
    retail_price: z.coerce
        .number()
        .min(0.1, 'Retail price must be greater than 0'),
    expiration_date: z.date(),
});
export const CreateStockSchema = z.object({
    supplier_id: z.string().min(1, 'Supplier is required'),
    note: z.string().default(''),
    products: z.array(StockItemSchema),
    total_price: z.coerce.number().min(0, 'Total price must be greater than 0'),
    total_paid: z.coerce.number().min(0, 'Total paid must be greater than 0'),
});
export const SubmissionSchema = CreateStockSchema.pick({
    supplier_id: true,
    note: true,
    total_paid: true,
    total_price: true,
});

export type SubmissionData = z.infer<typeof SubmissionSchema>;
export type CreateStock = z.infer<typeof CreateStockSchema>;
export type StockItem = z.infer<typeof StockItemSchema>;
